import { useEffect } from "react";
import downarrow from "../../assets/images/downarrow.svg";
import uparrow from "../../assets/images/uparrow.svg";
import { Form, Nav, Tab } from "react-bootstrap";
import close from "../../assets/images/close.svg";
import { commonservices } from "../../services/CommonServices";
import { useDispatch, useSelector } from "react-redux";
import {
  setWorkFlowGetListData,
  WorkFlowGetList,
} from "../../services/ReduxTookit/Slice/WorkFlowRedux";
import CustomSelect from "../ConfigurationComponent/CustomSelect";

function SortAndFilterPopup({
  searchValue,
  setSearchValue,
  handleshowPopup,
  getData,
  workspaceListOpt,
  FnForSetWorkspaceFilter,
  FnForSetValue,
  FnForSetLastRun,
  FnForSetLastRunDate,
  FnForSetLoading,
  FnForSetNextRun,
  FnForSetNextRunDate,
  FnForSetBillingStart,
  FnForSetBillingEnd,
  FnForSetStatus,
  FnForSetSort,
  FnForSetSortOrder,
  workspaceFilter,
  value,
  lastRun,
  nextRun,
  billingStart,
  billingEnd,
  status,
  sort,
  sortOrder,
}) {
  // const [value, setValue] = useState(0);
  // const [lastRun, setLastRun] = useState(undefined);
  const dispatch = useDispatch();
  // const [lastRunDate, setLastRunDate] = useState();

  // const [loading, setLoading] = useState(false);
  // const [nextRun, setNextRun] = useState(undefined);

  // const [nextRunDate, setNextRunDate] = useState();

  // const [billingStart, setBillingStart] = useState(0);
  // const [billingEnd, setBillingEnd] = useState(0);

  // const [status, setStatus] = useState("");
  // const [sort, setSort] = useState("machine");
  // const [sortOrder, setSortOrder] = useState("ASC");

  async function getWorkFlowList(e) {
    FnForSetLoading(true);
    let body = {
      searchText: searchValue,
      workflowname: "",
      subscriberid: "",
      sortfield: sort,
      sortorder: sortOrder,
      machinecount: value,
      lastrunon: lastRun ? lastRun : "",
      lastrunonstartdate: "",
      lastrunonenddate: "",
      nextschedule: nextRun ? nextRun : "",
      nextschedulestartdate: "",
      nextscheduleenddate: "",
      status: status ? status : "",
      workspace: workspaceFilter?.map((item) => item.label).join(",") ?? "",
    };
    if (billingStart) {
      body.billingstart = billingStart;
    }
    if (billingEnd) {
      body.billingend = billingEnd;
    }
    dispatch(WorkFlowGetList(body));
    handleshowPopup();
  }

  const getWorkFlowGetListData = useSelector(
    (item) => item?.workflowredux?.WorkFlowGetListData?.data,
  );

  useEffect(() => {
    if (getWorkFlowGetListData && getWorkFlowGetListData?.isValidate) {
      getData(getWorkFlowGetListData?.data?.data);
      // handleshowPopup();
      FnForSetLoading(false);
    }
    if (getWorkFlowGetListData && !getWorkFlowGetListData?.isValidate) {
      getData(null);
      FnForSetLoading(false);
      // handleshowPopup();
    }
    return () => {
      dispatch(setWorkFlowGetListData());
    };
  }, [getWorkFlowGetListData]);

  useEffect(() => {
    updateSliderBackground(value);
  }, [value]);

  const handleChange = (event) => {
    FnForSetValue(event.target.value);
  };

  const updateSliderBackground = (value) => {
    const slider = document.getElementById("slider");
    const percentage = ((value - slider.min) / (slider.max - slider.min)) * 100;
    slider.style.background = `linear-gradient(to right, #2196F3 ${percentage}%, #e5e5e5 ${percentage}%)`;
  };
  return (
    <Tab.Container
      id="left-tabs-example"
      defaultActiveKey="first"
      className="underlined-tabing"
    >
      <div className="schedular-popup sort-and-filter-popup workflow-filter-box">
        <div className="popup-title d-block p-0">
          <Nav variant="pills" className="flex">
            <Nav.Item>
              <Nav.Link eventKey="first">Filter</Nav.Link>
            </Nav.Item>
            <Nav.Item className="position-relative">
              <Nav.Link eventKey="second">Sort</Nav.Link>
              <img
                src={close}
                alt="close"
                id="sort-filter"
                className="cursor-pointer"
                onClick={(e) => {
                  handleshowPopup(e);
                }}
              />
            </Nav.Item>
          </Nav>
        </div>
        <div className="popup-body">
          <Tab.Content>
            <Tab.Pane eventKey="first">
              <div className="single-filter">
                <div className="d-flex align-items-center justify-content-between common-tab-titles">
                  <h5 className="">Machine</h5>
                  <span className="theme-color-text fw600">{value}</span>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <span className="range-input-main-span">-</span>
                  <input
                    type="range"
                    min="0"
                    max="50"
                    id="slider"
                    value={value}
                    className="range-input-main"
                    onChange={handleChange}
                  />
                  <span className="range-input-main-span">+</span>
                </div>
              </div>
              <div className="single-filter">
                <div className="d-flex align-items-center justify-content-between common-tab-titles">
                  <h5 className="">Workspace</h5>
                </div>
                <div className="all-grey-blue-badges">
                  <Form.Group className="form-group w-100">
                    <CustomSelect
                      isMulti
                      placeholder="Select Workspace"
                      options={workspaceListOpt}
                      value={workspaceFilter}
                      setValue={FnForSetWorkspaceFilter}
                      name="workspaces"
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="single-filter">
                <div className="d-flex align-items-center justify-content-between common-tab-titles">
                  <h5 className="">Last Run</h5>
                </div>
                <div className="all-grey-blue-badges">
                  <span
                    className={
                      lastRun === "yesterday"
                        ? "grey-badge active"
                        : "grey-badge"
                    }
                    onClick={() => FnForSetLastRun("yesterday")}
                  >
                    Yesterday
                  </span>
                  <span
                    className={
                      lastRun === 3 ? "grey-badge active" : "grey-badge"
                    }
                    onClick={() => FnForSetLastRun(3)}
                  >
                    3 Days
                  </span>
                  <span
                    className={
                      lastRun === 7 ? "grey-badge active" : "grey-badge"
                    }
                    onClick={() => FnForSetLastRun(7)}
                  >
                    7 Days
                  </span>
                  <span
                    className={
                      lastRun === 14 ? "grey-badge active" : "grey-badge"
                    }
                    onClick={() => FnForSetLastRun(14)}
                  >
                    14 Days
                  </span>
                  <span
                    className={
                      lastRun === 30 ? "grey-badge active" : "grey-badge"
                    }
                    onClick={() => FnForSetLastRun(30)}
                  >
                    1 Month
                  </span>
                  <span
                    className={
                      lastRun === 365 ? "grey-badge active" : "grey-badge"
                    }
                    onClick={() => FnForSetLastRun(365)}
                  >
                    1 Year
                  </span>
                </div>
              </div>
              <div className="single-filter">
                <div className="d-flex align-items-center justify-content-between common-tab-titles">
                  <h5 className="">Next Schedules</h5>
                </div>
                <div className="all-grey-blue-badges">
                  <span
                    className={
                      nextRun === "tomorrow"
                        ? "grey-badge active"
                        : "grey-badge"
                    }
                    onClick={() => FnForSetNextRun("tomorrow")}
                  >
                    Tomorrow
                  </span>
                  <span
                    className={
                      nextRun === 3 ? "grey-badge active" : "grey-badge"
                    }
                    onClick={() => FnForSetNextRun(3)}
                  >
                    3 Days
                  </span>
                  <span
                    className={
                      nextRun === 7 ? "grey-badge active" : "grey-badge"
                    }
                    onClick={() => FnForSetNextRun(7)}
                  >
                    7 Days
                  </span>
                  <span
                    className={
                      nextRun === 14 ? "grey-badge active" : "grey-badge"
                    }
                    onClick={() => FnForSetNextRun(14)}
                  >
                    14 Days
                  </span>
                  <span
                    className={
                      nextRun === 30 ? "grey-badge active" : "grey-badge"
                    }
                    onClick={() => FnForSetNextRun(30)}
                  >
                    1 Month
                  </span>
                  <span
                    className={
                      nextRun === 365 ? "grey-badge active" : "grey-badge"
                    }
                    onClick={() => FnForSetNextRun(365)}
                  >
                    1 Year
                  </span>
                </div>
              </div>
              <div className="single-filter">
                <div className="d-flex align-items-center justify-content-between common-tab-titles">
                  <h5 className="">Billings</h5>
                </div>
                <div className="all-grey-blue-badges">
                  <span
                    className={
                      billingStart === 0 && billingEnd === 5
                        ? "grey-badge active"
                        : "grey-badge"
                    }
                    onClick={() => {
                      FnForSetBillingStart(0);
                      FnForSetBillingEnd(5);
                    }}
                  >
                    $0.00 - $5.00
                  </span>
                  <span
                    className={
                      billingStart === 5 && billingEnd === 20
                        ? "grey-badge active"
                        : "grey-badge"
                    }
                    onClick={() => {
                      FnForSetBillingStart(5);
                      FnForSetBillingEnd(20);
                    }}
                  >
                    $5.00 - $20.00
                  </span>
                  <span
                    className={
                      billingStart === 20 && billingEnd === 40
                        ? "grey-badge active"
                        : "grey-badge"
                    }
                    onClick={() => {
                      FnForSetBillingStart(20);
                      FnForSetBillingEnd(40);
                    }}
                  >
                    $20.00 - $40.00
                  </span>

                  <span
                    className={
                      billingStart === 40 && billingEnd === 80
                        ? "grey-badge active"
                        : "grey-badge"
                    }
                    onClick={() => {
                      FnForSetBillingStart(40);
                      FnForSetBillingEnd(80);
                    }}
                  >
                    $40.00 - $80.00
                  </span>
                  <span
                    className={
                      billingStart === 80 && billingEnd === 120
                        ? "grey-badge active"
                        : "grey-badge"
                    }
                    onClick={() => {
                      FnForSetBillingStart(80);
                      FnForSetBillingEnd(120);
                    }}
                  >
                    $80.00 - $120.00
                  </span>
                  <span
                    className={
                      billingStart === 120 && billingEnd === 1000
                        ? "grey-badge active"
                        : "grey-badge"
                    }
                    onClick={() => {
                      FnForSetBillingStart(120);
                      FnForSetBillingEnd(1000);
                    }}
                  >
                    $120.00 - $1000.00
                  </span>
                </div>
              </div>
              <div className="single-filter">
                <div className="d-flex align-items-center justify-content-between common-tab-titles">
                  <h5 className="">Status</h5>
                </div>
                <div className="all-grey-blue-badges">
                  <span
                    className={
                      status === "Draft" ? "grey-badge active" : "grey-badge"
                    }
                    onClick={() => FnForSetStatus("Draft")}
                  >
                    Draft
                  </span>
                  <span
                    className={
                      status === "Active" ? "grey-badge active" : "grey-badge"
                    }
                    onClick={() => FnForSetStatus("Active")}
                  >
                    Active
                  </span>

                  <span
                    className={
                      status === "Suspend" ? "grey-badge active" : "grey-badge"
                    }
                    onClick={() => FnForSetStatus("Suspend")}
                  >
                    Suspend
                  </span>
                </div>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="second">
              <div className="single-sorting">
                <h5>Machine</h5>
                <div className="single-sorting-right">
                  <div
                    className={
                      sort === "machine" && sortOrder === "DESC" ? "active" : ""
                    }
                  >
                    <img
                      src={downarrow}
                      alt="downarrow"
                      onClick={() => {
                        FnForSetSortOrder("DESC");
                        FnForSetSort("machine");
                      }}
                    />
                  </div>
                  <div
                    className={
                      sort === "machine" && sortOrder === "ASC" ? "active" : ""
                    }
                  >
                    <img
                      src={uparrow}
                      alt="uparrow"
                      onClick={() => {
                        FnForSetSortOrder("ASC");
                        FnForSetSort("machine");
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="single-sorting">
                <h5>Workflow Name</h5>
                <div className="single-sorting-right">
                  <div
                    className={
                      sort === "workflowname" && sortOrder === "DESC"
                        ? "active"
                        : ""
                    }
                  >
                    <img
                      src={downarrow}
                      alt="downarrow"
                      onClick={() => {
                        FnForSetSortOrder("DESC");
                        FnForSetSort("workflowname");
                      }}
                    />
                  </div>
                  <div
                    className={
                      sort === "workflowname" && sortOrder === "ASC"
                        ? "active"
                        : ""
                    }
                  >
                    <img
                      src={uparrow}
                      alt="uparrow"
                      onClick={() => {
                        FnForSetSortOrder("ASC");
                        FnForSetSort("workflowname");
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="single-sorting">
                <h5>Last Run</h5>
                <div className="single-sorting-right">
                  <div
                    className={
                      sort === "lastrunon" && sortOrder === "DESC"
                        ? "active"
                        : ""
                    }
                  >
                    <img
                      src={downarrow}
                      alt="downarrow"
                      onClick={() => {
                        FnForSetSortOrder("DESC");
                        FnForSetSort("lastrunon");
                      }}
                    />
                  </div>
                  <div
                    className={
                      sort === "lastrunon" && sortOrder === "ASC"
                        ? "active"
                        : ""
                    }
                  >
                    <img
                      src={uparrow}
                      alt="uparrow"
                      onClick={() => {
                        FnForSetSortOrder("ASC");
                        FnForSetSort("lastrunon");
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="single-sorting">
                <h5>Next Schedules</h5>
                <div className="single-sorting-right">
                  <div
                    className={
                      sort === "nextrunon" && sortOrder === "DESC"
                        ? "active"
                        : ""
                    }
                  >
                    <img
                      src={downarrow}
                      alt="downarrow"
                      onClick={() => {
                        FnForSetSortOrder("DESC");
                        FnForSetSort("nextrunon");
                      }}
                    />
                  </div>
                  <div
                    className={
                      sort === "nextrunon" && sortOrder === "ASC"
                        ? "active"
                        : ""
                    }
                  >
                    <img
                      src={uparrow}
                      alt="uparrow"
                      onClick={() => {
                        FnForSetSortOrder("ASC");
                        FnForSetSort("nextrunon");
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="single-sorting">
                <h5>Billings</h5>
                <div className="single-sorting-right">
                  <div
                    className={
                      sort === "billings" && sortOrder === "DESC"
                        ? "active"
                        : ""
                    }
                  >
                    <img
                      src={downarrow}
                      alt="downarrow"
                      onClick={() => {
                        FnForSetSortOrder("DESC");
                        FnForSetSort("billings");
                      }}
                    />
                  </div>
                  <div
                    className={
                      sort === "billings" && sortOrder === "ASC" ? "active" : ""
                    }
                  >
                    <img
                      src={uparrow}
                      alt="uparrow"
                      onClick={() => {
                        FnForSetSortOrder("ASC");
                        FnForSetSort("billings");
                      }}
                    />
                  </div>
                </div>
              </div>
            </Tab.Pane>
          </Tab.Content>
        </div>
        <div className="popup-footer">
          <button
            className="grey-btn"
            id="sort-filter"
            onClick={(e) => {
              setSearchValue("");
              FnForSetWorkspaceFilter([]);
              FnForSetValue(0);
              FnForSetLastRun();
              FnForSetNextRun();
              FnForSetLastRunDate(commonservices?.GetCurrentDate);
              FnForSetNextRunDate(commonservices?.GetCurrentDate);
              FnForSetBillingStart(0);
              FnForSetBillingEnd(0);
              FnForSetStatus(null);
              FnForSetSort("machine");
              FnForSetSortOrder("ASC");
            }}
          >
            Reset
          </button>
          {/* {loading ? (
            <button className="blue-btn">Loading...</button>
          ) : ( */}
          <button className="blue-btn" onClick={(e) => getWorkFlowList(e)}>
            Submit
          </button>
          {/* )} */}
        </div>
      </div>
    </Tab.Container>
  );
}

export default SortAndFilterPopup;
